import { sortMode, filterMode, TextQNAState, TextQADetail } from './types';
import { BroadcastActions } from '../user/types';

import i18n from '@/i18n';
import loggerService from '@/services/logger.service';
import { RootState } from '@/store';
const getters = {
  isLoadingTextQAPosts(state: TextQNAState) {
    if (state.textQnA?.id) {
      return state.textQnA.qnaState === 'loading';
    }
    return false;
  },
  textQnaQuestions(state: TextQNAState): TextQADetail {
    if (state.textQnA?.detail) {
      return state.textQnA.detail;
    }
    return {
      numberOfUserUnModdedQues: 0,
      publishedQuestion: null,
      questions: [],
      totalNoOfQuestions: 0
    };
  },
  publishedTextQNA(state: TextQNAState) {
    try {
      if (state.textQnA?.detail?.publishedQuestion) {
        return state.textQnA?.detail?.publishedQuestion;
      }

      return null;
    } catch (e) {
      loggerService.error('Published text qna not found!', e);
      return null;
    }
  },
  textQNADetails(state: TextQNAState, getters: any) {
    if (state.textQnA) {
      const textQnaQuestions = getters['textQnaQuestions'];
      return {
        questions: textQnaQuestions?.questions || [],
        newQnaPresent: false,
        sortingMethods: getters['filteringAndSortingOptions'].sortingOptions,
        filteringMethods: getters['filteringAndSortingOptions'].filteringOptions,
        sortedBy: state.textQnA.sortmode,
        filteredBy: state.textQnA.filtermode,
        numberOfUserUnmoddedPosts: textQnaQuestions?.numberOfUserUnModdedQues || 0,
        totalNoOfQuestions: textQnaQuestions?.totalNoOfQuestions || 0
      };
    }
  },
  filteringAndSortingOptions(state: TextQNAState, getters: any, rootState: RootState, rootGetters: any) {
    const isBroadcastSpeakerOrOrganizer = rootGetters['event/isBroadcastSpeakerOrOrganizer'];
    const currentEvent = rootGetters['event/currentEvent'];

    const sortingOptions = [
      {
        // @ts-ignore - TS2589: Type instantiation is excessively deep (vue-i18n type inference issue)
        label: i18n.global.t('@@translate@@ Most Upvotes'),
        value: sortMode.UPVOTES
      },
      {
        label: i18n.global.t('@@translate@@ Most Recent'),
        value: sortMode.RECENT
      }
    ];

    let filteringOptions = [
      {
        label: i18n.global.t('@@translate@@ All'),
        value: filterMode.ALL
      },
      {
        label: i18n.global.t('@@translate@@ My Questions'),
        value: filterMode.MYQUESTIONS
      }
    ];

    if (isBroadcastSpeakerOrOrganizer) {
      filteringOptions = [
        {
          label: i18n.global.t('@@translate@@ All'),
          value: filterMode.ALL
        },
        {
          label: i18n.global.t('@@translate@@ Prioritized'),
          value: filterMode.PRIORITIZED
        },
        //@ts-ignore
        ...(state.textQnA?.isModerated
          ? [
              {
                label: i18n.global.t('@@translate@@ Approved'),
                value: filterMode.APPROVED
              },
              {
                label: i18n.global.t('@@translate@@ Unapproved'),
                value: filterMode.UNAPPROVED
              }
            ]
          : []),
        {
          label: i18n.global.t('@@translate@@ Answered'),
          value: filterMode.ANSWERED
        },
        {
          label: i18n.global.t('@@translate@@ Unanswered'),
          value: filterMode.UNANSWERED
        },

        {
          label: i18n.global.t('@@translate@@ My Questions'),
          value: filterMode.MYQUESTIONS
        },
        ...(isBroadcastSpeakerOrOrganizer && currentEvent?.assign_speaker_qna
          ? [
              {
                label: i18n.global.t('@@translate@@ Unassigned'),
                value: filterMode.UNASSIGNED
              }
            ]
          : [])
      ];
    }

    return { sortingOptions, filteringOptions };
  },
  isTextQAndAActionPermitted:
    (state: TextQNAState, getters: any, rootState: RootState, rootGetters: any) =>
    (action: BroadcastActions): boolean => {
      const isBroadcastActionPermitted = rootGetters['isBroadcastActionPermitted'];
      const currentBroadcast = rootGetters['event/currentBroadcast'];

      if (action) {
        return isBroadcastActionPermitted(action, currentBroadcast.id);
      }

      return isBroadcastActionPermitted(BroadcastActions.CONTROL_Q_AND_A, currentBroadcast.id) ?? false;
    }
};

export type TextQnAGetters = {
  [k in keyof typeof getters]: ReturnType<(typeof getters)[k]>;
};

export default getters;
